;(function ($) {


    // Set heading in contact modal according to selected division

    $('.js-contactForm').click( function(ev) {
        let modalTitle = $(this).data('division')

        $('.js-contactForm-title').html(modalTitle)
    } )


})(jQuery);
